var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('Cover',{attrs:{"index":"999","visible":_vm.loading}},[_c('img',{staticClass:"loadingImage",attrs:{"src":require("@/assets/loading.gif")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }